import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { PagerService } from '../../services/pager.service';

@Component({
    selector: 'app-pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.css']
})
export class PaginationComponent implements OnInit, OnChanges {
    pager: any;
    pagedItems: any[];
    pageSize: number;
    initialSize = 8;
    pageSizes: number[] = new Array();
    pagerData: Pager;
    maxPerPage = 32;

    @Input() itemsCount: number;
    @Output() setPageData = new EventEmitter<Pager>();
    constructor(private _pagerService: PagerService) {

    }
    ngOnInit(): void {
        this.loadPageData();
    }

    ngOnChanges() {
        this.loadPageData();
    }

    loadPageData() {
        this.pager = {};
        this.pageSizes = [];
        this.pageSize = 8;
        this.setPage(1);
        this.setPageSizeValues();
    }

    setPage(page: number) {
        if (page < 1 || page > this.pager.totalPages) {
            return;
        }
        this.pager = this._pagerService.getPager(this.itemsCount, page, parseInt(this.pageSize.toString()));
        this.pagerData = new Pager(this.pager.startIndex, this.pager.endIndex + 1);
        this.setPageData.emit(this.pagerData);
    }
    setPageSizeValues() {
        this.pageSizes.push(this.initialSize);
        while (this.initialSize < this.itemsCount && this.initialSize < this.maxPerPage) {
            this.initialSize = this.initialSize * 2;
            this.pageSizes.push(this.initialSize);
        }
        this.initialSize = 8;
    }

}

export class Pager {
    constructor(public startIndex: number, public endIndex: number) {

    }
}



// WEBPACK FOOTER //
// ./src/opc/shared/components/pagination/pagination.component.ts